import type { CountryPack } from '../../domain';
import type { ReviewContentPort } from '../../application/ports';

/** The pack the scholars' review screen reads, as it is: review is not an environment that ships. */
export class ReviewContentAdapter implements ReviewContentPort {
  constructor(private readonly pack: CountryPack) {}

  async load(): Promise<CountryPack> {
    return this.pack;
  }
}
